import { useState } from 'react';
import { saveFeedback } from '@api/save-feedback';
import { Feedback, IMessage, Modals } from '@common/types';
import { Button } from '@components/ui/button';
import { useTranslation } from 'react-i18next';
import AnswerMessageContainer from './answer-message-container';
import FeedbackPanel from './feedback-panel';
import MarkdownResponse from './markdown-response';
import SourcesDropdown from './sources-dropdown';

interface ICompleteResponseProps {
  message: IMessage;
  onShowMoreAnswers: (messageId: number) => void;
  showModal: (type: Modals) => void;
}

function CompleteResponse(props: ICompleteResponseProps) {
  const { t } = useTranslation();
  const [feedbackSent, setFeedbackSent] = useState<boolean>(false);

  async function handleFeedback(feedback: Feedback) {
    if (props.message.queryId && props.message.questionId) {
      await saveFeedback({
        queryId: props.message.queryId,
        questionId: props.message.questionId,
        value: feedback,
      });
      setFeedbackSent(true);
    }
  }

  const textMessage = props.message.message || '';

  return (
    <div className="mb-5">
      <AnswerMessageContainer>
        {props.message.questionQuery && (
          <div>
            <i>
              <p>
                {t('chat.response.found_answer_for')} &laquo;
                {props.message.questionQuery}&raquo;
              </p>
            </i>
          </div>
        )}

        <MarkdownResponse message={textMessage} />
        <footer className="flex justify-between items-center mt-5">
          <div />
          <section className="flex justify-between items-center gap-6">
            <Button
              className="bg-xircle-main text-xs hover:bg-xircle-secondary"
              onClick={() => props.onShowMoreAnswers(props.message.id)}
            >
              {t('chat.alternative_answers')}
            </Button>
            {!feedbackSent && <FeedbackPanel submit={handleFeedback} />}
          </section>
        </footer>
      </AnswerMessageContainer>
      <section className="w-full sm:w-3/5 flex justify-center items-center gap-3 px-5">
        <SourcesDropdown sourceDocuments={props.message.sourceDocuments} />
        <Button
          className="bg-xircle-secondary w-full"
          onClick={() => props.showModal(Modals.MedicalInfo)}
        >
          {t('chat.info_service')}
        </Button>
      </section>
    </div>
  );
}

export default CompleteResponse;
